<app-job-pointe-settings-bar
  *ngIf="!tableData.hideTableBar"
  [filters]="tableFilters"
  [moreFilters]="moreFilters"
  [jobPointeSettingsData]="tableData"
  [source]="source"
  (search)="performSearch($event)"
  (create)="performCreate($event)"
  (filter)="performFilter($event)"
  (clear)="performClear()"
  (transfer)="handleAction({ action: 'transfer', source: 'tools' })"
  (action)="handleAction($event)"
  (exportEmployees)="performEmployeeBatchExport($event)"></app-job-pointe-settings-bar>
<app-job-pointe-settings-table
  [headers]="tableData"
  [rows]="tableData.data"
  [totalItems]="tableData.pagination?.totalCount"
  [getData]="getData.bind(this)"
  [meta]="tableData.meta"
  [source]="source"
  [(selected)]="selectedItems"
  (action)="handleAction($event)"
  (selectedChange)="handleSelectedChange($event)"
  (selectedAdd)="handleSelectedAdd($event)"
  (selectedRemove)="handleSelectedRemove($event)"
  (selectedAll)="handleSelectAll($event)"
  (refreshSelectAll)="refreshDataForSelectAll($event)"
  (removeAll)="handleRemoveAll($event)">
</app-job-pointe-settings-table>
<app-tool-settings-paging
  *ngIf="!tableData.hideTablePaging"
  [links]="tableData.pagination"
  (navigation)="performPaging($event)"></app-tool-settings-paging>

<!-- model dialog prompt -->
<app-dialog id="delete-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">{{ dialogRecord.actionName }} {{ dialogRecord?.data?.toolId }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'delete'">
      Are you sure you want to {{ dialogRecord.actionName | lowercase }} <b>{{ dialogRecord?.name }}</b
      >?
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary" id="delete-dialog_btn-ok">Continue</button>
  </span>
</app-dialog>
